/** Add or remove one member of a token list, keeping the vocabulary's order. */
export function toggleToken<T extends string>(list: readonly T[], value: T, order: readonly T[]): T[] {
  const next = new Set(list);
  if (next.has(value)) next.delete(value);
  else next.add(value);
  return order.filter((option) => next.has(option));
}
